import { Component } from "@angular/core";

import { Tab, NavParams, MenuController, NavController } from "ionic-angular";
import { AddOrderServiceProvider } from "./../add-order.service";

import { CustomerPage } from "../customer/customer";
import { AddressPage } from "../address/address";
import { AddCropPage } from "../addcrop/addcrop";
import { AddMiscPage } from "../addmisc/addmisc";
import { PlaceOrderPage } from "../placeorder/placeorder";

@Component({
  selector: "tabs-addorder",
  templateUrl: "tabs-addorder.html"
})
export class TabAddOrder {
  // set the root pages for each tab
  customer: any = CustomerPage;
  address: any = AddressPage;
  crop: any = AddCropPage;
  misc: any = AddMiscPage;
  order: any = PlaceOrderPage;

  action_type: any = "Add Opportunity";

  constructor(
    navParams: NavParams,
    public menu: MenuController,
    public addOrderService: AddOrderServiceProvider,
    public navCtrl: NavController
  ) {
    this.addOrderService.external_mobile_number = navParams.get("mobile_no");
    this.action_type = navParams.get("action_type");

    if (typeof this.action_type === "undefined") {
      this.action_type = "Add Opportunity";
    }

    if (navParams.data.tabIndex != null) {
    }

    navParams.data = navParams.data;
  }

  ionViewDidLoad() {
    this.menu.enable(true);
  }

  tabChanged(tab: Tab) {
    // if (tab.index == 2) {
    // }
    // if (tab.index == 2) {
    // }
    // if (tab.index == 2) {
    // }
    // if (tab.index == 2) {
    // }
  }
}



// WEBPACK FOOTER //
// ./src/pages/addorder/tabs/tab-addorder.ts